import React from "react";
import { Image, Container, Row, Col } from "react-bootstrap";

//Images
import heroMainImg from "../../assets/img/hero-img.png";
import icon1 from "../../assets/img/main-1.svg";
import icon2 from "../../assets/img/main-2.png";
import icon3 from "../../assets/img/main-3.svg";
import screens from "../../assets/img/screens.png";

//Components
import DownloadSection from "../../components/Download-section/download-section";
import Feedbacks from "../../components/Feedbacks/feedbacks";
import Form from "../../components/Form/Form";
import Footer from "../../components/Footer/Footer";

const Homepage = () => {
  return (
    <React.Fragment>
      <div className="form-wrapper">
        <section id="hero">
          <Container fluid className="pt-5">
            <Container className="pt-5">
              <Row>
                <Col md={6}>
                  <h2 className="display-5 brand-font" data-aos="fade-in">
                    Building a world that fits your world–Together.
                    <br />
                  </h2>
                  <p className="hero-p" data-aos="fade-in" data-aos-delay="400">
                    The world is constantly changing, quickly. Every minute
                    counts. Every minute matters. We understand this and are
                    committed to Israel’s most advanced shipping standards. That
                    is why we established a professional and reliable community
                    of drivers with which we can promise –
                    <br />
                    Delivery within two hours.
                  </p>
                  <Image
                    src={heroMainImg}
                    fluid
                    alt="Screenshot"
                    data-aos="fade-up"
                  />
                </Col>
              </Row>
            </Container>
          </Container>
        </section>

        {/* Main Section */}
        <section id="main">
          <Container className="pt-5 pb-5">
            <h2
              className="display-4 container brand-font"
              data-aos="fade-up"
              data-aos-anchor-placement="top-bottom"
            >
              How does it work?{" "}
            </h2>
            <Col
              md={12}
              className="d-flex"
              data-aos="fade-left"
              data-aos-delay="100"
            >
              <Image
                src={icon1}
                width="100px"
                height="100px"
                fluid
                alt="Ideal icon"
              />
              <div className="pr-3">
                <h2 className="display-3">
                  <span className="brand-font"> Go into dibble</span>
                </h2>
                <p className="main-p">
                  Choose products out of a huge variety, fill your shopping
                  cart, pay on the app and choose your delivery time <br />
                  (2-hour option too).{" "}
                </p>
              </div>
            </Col>

            <Col md={12} className="py-5 d-flex" data-aos="fade-left">
              <Image
                src={icon2}
                width="100px"
                height="100px"
                alt="Stores icon"
              />
              <div className="pr-3">
                <h2 className="brand-font">Stores near you</h2>
                <p className="main-p">
                  Can offer the best price for your shopping cart – all within
                  minutes. Once the order is approved at the store, <br />
                  they will be taken off the shelf and our driver will be
                  called.
                  <br />
                </p>
              </div>
            </Col>
            <Col className="col-12 d-flex" data-aos="fade-left">
              <Image src={icon3} width="100px" height="100px" alt="couriers " />
              <div className="pr-3">
                <h2 className="display-3">
                  <span className="brand-font">Dibbles drivers</span>
                </h2>
                <p className="main-p">
                  Are already on their way (to your office, site or home) with
                  everything that you bought. When the delivery arrives, <br />
                  you will be asked to sign for it and confirm that everything
                  is in order. Simple, right?{" "}
                </p>
              </div>
            </Col>
          </Container>
        </section>
        {/* End Main Section */}

        {/* <!-- ======= clients Section ======= --> */}
        <section id="clients">
          <Container
            className="gray-bg bg-light"
            fluid
            data-aos="fade-in"
            data-aos-duration="2500"
          >
            <Container className="pt-5">
              <Col md={6}>
                <h2 className="display-4">
                  <span className="brand-font">Who can order on dibble?</span>
                </h2>
                <div className="d-flex justify-content-end">
                  <p className="main-p">
                    We will soon be launching the service for everyone, but
                    right now, it is dedicated to contractors and professionals
                    seeking fast and available quality equipment.
                    <br />
                    Want to join the dibble professional community? <br />
                    <strong>
                      Register now, chat with us and... start ordering.
                    </strong>
                  </p>
                </div>
                <Image src={screens} fluid alt="clients icon" />
              </Col>
            </Container>
          </Container>
        </section>
        <Form />
      </div>
      <DownloadSection />
      <Feedbacks />
      <Footer />
    </React.Fragment>
  );
};

export default Homepage;
